<template>
  <div class="document-item">
    <div class="document-item__data">
      <div class="document-item__name">{{ document.name }}</div>

      <div v-if="hasColorMarks" class="document-item__colors">
        <document-issue-mark
          v-if="document.absent_color"
          class="document-item__color"
          issue="absent"
          :color="document.absent_color"
        ></document-issue-mark>
        <document-issue-mark
          v-if="document.expired_color"
          class="document-item__color"
          issue="expired"
          :color="document.expired_color"
        ></document-issue-mark>
        <document-issue-mark
          v-if="document.expiring_color"
          class="document-item__color"
          issue="expiring"
          :color="document.expiring_color"
        ></document-issue-mark>
      </div>

      <div v-if="criticalityLabel" class="document-item__criticality">
        <span>{{ criticalityLabel }}</span>
        <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.733 3.045L3.9 3.344L5.213 4.67L3.783 5.71L2.925 4.059L2.067 5.723L0.637 4.683L1.937 3.357L0.104 3.045L0.637 1.407L2.301 2.213L2.041 0.353999H3.809L3.536 2.226L5.187 1.394L5.733 3.045Z"
            fill="#FF238D"
          />
        </svg>
      </div>
    </div>
    <div class="document-item__actions">
      <c-button-2
        class="document-item__edit"
        size="iconic"
        icon="edit"
        @click="$router.push({ name: 'edit-document', params: { id: document.id } })"
      />

      <c-button-2
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          boundary: 'window',
          content: document.is_archive ? 'Восстановить' : 'Добавить в архив',
          placement: 'top',
        }"
        class="documents-group__edit"
        size="iconic"
        icon="box-arhive"
        @click="onArchive"
      />

      <span :id="`document-remove-wrapper-${document.id}`">
        <c-button-2
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            boundary: 'window',
            content: 'Удалить',
            placement: 'top',
          }"
          class="document-item__remove"
          size="iconic"
          :icon="{ icon: 'trash', color: 'secondary' }"
          :disabled="!document.canDelete"
          @click="onRemove"
        />
      </span>

      <b-popover
        v-if="!document.canDelete"
        placement="top"
        triggers="hover blur"
        :target="`document-remove-wrapper-${document.id}`"
      >
        <error-feedback
          class="m-0 empty-category-tooltip"
          text="В данный момент удаление невозможно, так как документ добавлен для сотрудников."
        ></error-feedback>
      </b-popover>

      <c-button-2 class="document-item__move" size="iconic" icon="arrows-constructor" />
    </div>
  </div>
</template>

<script>
import Button2 from "@/components/controls2/Button";
import DocumentIssueMark from "./document-issue-mark";
import ErrorFeedback from "@/components/error-feedback";

export default {
  name: "document-item",
  components: {
    "c-button-2": Button2,
    "document-issue-mark": DocumentIssueMark,
    ErrorFeedback,
  },

  props: ["document", "selectedTab"],
  computed: {
    hasColorMarks() {

      return (this.document.critical || this.document.required) && (this.document.absent_color || this.document.expired_color || this.document.expiring_color);
    },
    criticalityLabel() {
      if (this.document.critical) return "Критичный";
      if (this.document.required) return "Обязательный";
      return "";
    },
  },

  methods: {
    onRemove() {
      this.$emit("remove", this.document);
    },

    onArchive() {
      this.$emit("archive");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.document-item {
  display: flex;
  align-items: center;
  min-height: 35px;
  padding: 8px 16px;
  // padding-right: 10px;
  border: 1px solid $color-border-light;
  cursor: pointer;

  @include onlyExtraSmall {
    border-right: none;
  }

  &__data {
    flex-grow: 1;
    display: flex;
    align-items: center;

    @include onlyExtraSmall {
      flex-wrap: wrap;
    }
  }

  &__name {
    font-size: 13px;
    margin-right: 16px;
    line-height: 1.08;
    word-break: break-word;
  }

  &__colors {
    display: flex;
    margin-right: 16px;
  }

  .document-item__color ~ .document-item__color {
    margin-left: 6px;
  }

  &__criticality {
    font-size: 11px;
    color: $color-secondary;
    margin-right: 16px;

    & svg {
      display: none;
    }

    @include onlyExtraSmall {
      height: 24px;
      display: flex;
      align-items: center;

      & span {
        display: none;
      }
      & svg {
        display: block;
      }
    }
  }

  &__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  &__edit {
    margin-right: 16px;
  }

  &__remove {
    margin-right: 15px;
    transform: translateY(-2px);
  }
}
.empty-category-tooltip {
  max-width: 200px;
}
</style>
